var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-filtered-search-ce',_vm._b({ref:"filteredSearch",attrs:{"ee-filters":_vm.filterParams},on:{"set-filters":function($event){return _vm.$emit('set-filters', $event)}}},'board-filtered-search-ce',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }